// BOUTONS FILTRES

document.querySelectorAll('.filter').forEach(element => {
    element.addEventListener('click', function(event) {
        event.preventDefault();
        element.classList.toggle('active');
    })
});
document.querySelectorAll('.equi-section__badge').forEach(element => {
    element.classList.toggle('active');
});
class Theme {
    constructor(filter, section) {
        this.filter = filter;
        this.section = section;
    }
}
let allThemesFilt = document.querySelectorAll('.filter-badge--all');
let allThemesMap = Array.from(allThemesFilt).map(element => {
    return element;
})
let eco = new Theme(document.querySelectorAll('.filter-badge--eco'), document.getElementById('equi-section--eco'));
let sani = new Theme(document.querySelectorAll('.filter-badge--sani'), document.getElementById('equi-section--sani'));
let sante = new Theme(document.querySelectorAll('.filter-badge--sante'), document.getElementById('equi-section--sante'));
let bienEtre = new Theme(document.querySelectorAll('.filter-badge--bien_etre'), document.getElementById('equi-section--bien_etre'));
let enviro = new Theme(document.querySelectorAll('.filter-badge--enviro'), document.getElementById('equi-section--enviro'));
let social = new Theme(document.querySelectorAll('.filter-badge--social'), document.getElementById('equi-section--social'));
let themeFilts = [eco, sani, sante, bienEtre, enviro, social];
// clic sur les filtres par thème
themeFilts.forEach(element => {
    let filter = element.filter;
    let section = element.section;
    filter.forEach(filt => {
        filt.addEventListener("click", function() {
            if(allThemesMap.find(el => el.classList.contains("active") == true)) {
                allThemesMap.forEach(el => el.classList.remove("active"));
                themeFilts.forEach(el => el.section.classList.remove("active"));
                section.classList.add("active");
            }
            if(filt.classList.contains("active") == true) {
                section.classList.add("active");
            } else {
                section.classList.remove("active");
            }
        })
    })
});
// clic sur les filtres de status (obtenu ou non)
class MedalsStatus {
    constructor(filter, medal) {
        this.filter = filter,
        this.medal = medal
    }
}
let locked = new MedalsStatus(document.getElementById('filter-badge--locked'), Array.from(document.querySelectorAll('.badge-locked')).map(medal => {return medal}));
let unlocked = new MedalsStatus(document.getElementById('filter-badge--unlocked'), Array.from(document.querySelectorAll('.badge-unlocked')).map(medal => {return medal}));
let medalsFilt = [locked, unlocked];
medalsFilt.forEach(element => {
    element.filter.addEventListener("click", function() {
        if(allThemesMap.find(el => el.classList.contains("active") == true)) {
            allThemesMap.forEach(el => el.classList.remove("active"));
        }
        if(element.filter.classList.contains("active") == true) {
            element.medal.forEach(el => {el.style.display = "block"});
        } else {
            element.medal.forEach(el => {el.style.display = "none"});
        }
    })
});
// clic sur le filtre "tous"
allThemesFilt.forEach(btn => {
    btn.addEventListener("click", function() {
        themeFilts.forEach(element => {
            element.filter.forEach(filt => {
                filt.classList.remove("active");
            });
            element.section.classList.add("active");
            btn.classList.add("active");
        })
        medalsFilt.forEach(element => {
            element.filter.classList.remove("active");
            element.medal.forEach(trophy => {trophy.style.display = "block"});
        })
    })
});


// Filtre select format mobile
const selectTheme = document.getElementById('theme-select');
const selectType = document.getElementById('type-select');
let selectThemeList = [
    selectEco = {
        title: 'Économique',
        section: document.getElementById('equi-section--eco')
    },
    selectSani = {
        title: 'Sanitaire',
        section: document.getElementById('equi-section--sani')
    },
    selectEnviro = {
        title: 'Environnement',
        section: document.getElementById('equi-section--enviro')
    },
    selectSocial = {
        title: 'Social',
        section: document.getElementById('equi-section--social')
    },
    selectSante = {
        title: 'Santé',
        section: document.getElementById('equi-section--sante')
    },
    selectBienEtre = {
        title: 'Bien-être',
        section: document.getElementById('equi-section--bien_etre')
    }
];
selectTheme.addEventListener("change", function() {
    let selectedTheme = selectTheme.value;
    if(selectedTheme == "allThemes") {
        selectThemeList.forEach(element => {
            element.section.classList.add("active");
        })
    } else {
        let selectedSection = selectThemeList.filter(el => el.title === selectedTheme)[0];
        selectThemeList.forEach(element => {
            element.section.classList.remove("active");
        })
        selectedSection.section.classList.add("active");
    }
})
selectType.addEventListener("change", function() {
    let selectedType = selectType.value;
    if(selectedType == "allTypes") {
        document.querySelectorAll(".badge").forEach(badge => {
            badge.style.display = "block";
        })
    } else if(selectedType == "get") {
        document.querySelectorAll(".badge-locked").forEach(badge => {
            badge.style.display = "none";
        })
        document.querySelectorAll(".badge-unlocked").forEach(badge => {
            badge.style.display = "block";
        })
    } else if(selectedType == "toGet") {
        document.querySelectorAll(".badge-unlocked").forEach(badge => {
            badge.style.display = "none";
        })
        document.querySelectorAll(".badge-locked").forEach(badge => {
            badge.style.display = "block";
        })
    }
})